export default class {
    constructor() {
        document.addEventListener("DOMContentLoaded", function () {
            $(".item").click(function () {
                if ($(this).hasClass("open")) {
                    $(this).removeClass("open");
                } else {
                    $(this).addClass("open");
                }
            });
        });
    }
}
